// cSpell:ignore Afrekening Decompte Décompte Eindafrekening frais huurcontract vertrek
// The description of a payment requested from a settlement. It is what the
// tenant reads on the payment request and it feeds the payout reference, so
// it is written in the tenant's language and only uses the characters a
// payout reference allows.

import {
  getSettlementTitle,
  TSettlementKind,
} from "@rentiohq/shared-frontend/dist/utils/settlement.utils";

// Combining marks left behind by NFD normalization ("é" → "e" + "´").
const COMBINING_MARKS = /[\u0300-\u036f]/g;
// Everything a payout reference refuses (see CONFIG.PAYOUT_REFERENCE_REGEX:
// letters, digits, spaces and + , - . / ( )).
const NOT_IN_PAYOUT_REFERENCE = /[^a-zA-Z0-9 +,\-./()]+/g;

// "Décompte des frais – été" → "Decompte des frais - ete": accents dropped,
// every other refused character replaced by a space. The dates' slashes and
// dashes stay.
export const toPaymentDescription = (text: string): string =>
  text
    .normalize("NFD")
    .replace(COMBINING_MARKS, "")
    .replace(/[\u2013\u2014]/g, "-")
    .replace(NOT_IN_PAYOUT_REFERENCE, " ")
    .replace(/\s+/g, " ")
    .trim();

// The settlement's name, in ASCII: the name the broker gave it, as typed
// (Lewis, 2026-10-16); without one its title in the tenant's language
// (getSettlementTitle): "Afrekening 01/01-30/06/2026", or for a departure
// "Eindafrekening bij vertrek - huurcontract tot 30/06/2026", the lease's
// last day being the period's end. The suggested name never holds a
// tenant's name (Q2).
export const getSettlementPaymentDescription = (params: {
  name?: string;
  kind?: TSettlementKind;
  period: { from: string; to: string };
  locale?: string;
}): string => {
  const { name, kind = "regular", period, locale } = params;
  return toPaymentDescription(
    name?.trim() ||
      getSettlementTitle({
        kind,
        from: period.from,
        to: period.to,
        withLeaseEnd: true,
        locale,
      }),
  );
};
